var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSvgErrorMsg = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#SvgErrorMsg_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#D81E06",
  d: "M8 16a8 8 0 0 1-8-8 8 8 0 0 1 8-8 8 8 0 0 1 8 8 8 8 0 0 1-8 8m-.482-6.73c.101.305.305.508.609.508.305 0 .508-.203.61-.508l.406-5.587c0-.61-.508-1.016-1.016-1.016-.61 0-1.016.508-1.016 1.117zm.609 1.524c-.61 0-1.016.406-1.016 1.015 0 .61.407 1.017 1.016 1.017.61 0 1.016-.407 1.016-1.017s-.407-1.015-1.016-1.015"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "SvgErrorMsg_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})))));
export default SvgSvgErrorMsg;